// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-row-light {\n  background-color: #FFFFFF;\n}\n\n.table-row-dark {\n  background-color: #F0F4F6;\n}\n", ""]);
// Exports
module.exports = exports;
